var _circle, _path, _circle2, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRectangle21CError = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 60",
  ref: ref
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 39.992,
  cy: 36,
  r: 6,
  fill: "#464D57",
  transform: "rotate(-180 39.992 36)"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#f39898",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M44.234 40.243a6 6 0 0 1-8.485 0"
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 19.991,
  cy: 36,
  r: 6,
  fill: "#464D57",
  transform: "rotate(-180 19.991 36)"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#f39898",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M24.234 40.243a6 6 0 0 1-8.485 0"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  d: "M10 17.5a2.5 2.5 0 0 1 2.5-2.5h35a2.5 2.5 0 0 1 2.5 2.5v7a2.5 2.5 0 0 1-2.5 2.5h-35a2.5 2.5 0 0 1-2.5-2.5v-7Z"
})));
SvgRectangle21CError.viewBox = '0 0 60 60';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRectangle21CError);
export default ForwardRef;